import { Accessibility } from '../graphql/__generated__/types/contento';
import ContentoAccessibilities from './ContentoAccessibilities';

enum AccessServiceTypes {
    NONE = 'none',
    AUDIODESCRIPTION = 'audioDescription',
    SIGNINTERPRETATION = 'signInterpretation',
    LIVECAPTIONING = 'liveCaptioning',
    SIGN_LANGUAGE = 'signLanguage',
}

const SIGNINTERPRETATION = 'teckenspråkstolkat';
const AUDIODESCRIPTION = 'syntolkat';
const DEFAULT = 'utan tolkning';

export function getAccessServiceDescription(
    accessService: AccessServiceTypes | ContentoAccessibilities | Accessibility,
    mainLanguage = null,
    hasMultipleLanguages = false
): string {
    if (accessService === AccessServiceTypes.NONE || accessService === ContentoAccessibilities.DEFAULT) {
        const language = mainLanguage?.name;

        return hasMultipleLanguages ? `på ${language.toLowerCase()}` : DEFAULT;
    }
    if (
        accessService === AccessServiceTypes.AUDIODESCRIPTION ||
        accessService === ContentoAccessibilities.AUDIO_DESCRIBED
    ) {
        return AUDIODESCRIPTION;
    }
    if (
        accessService === AccessServiceTypes.SIGNINTERPRETATION ||
        accessService === ContentoAccessibilities.SIGN_INTERPRETED
    ) {
        return SIGNINTERPRETATION;
    }

    return '';
}

export function mapToNewAccessService(
    accessService: AccessServiceTypes | ContentoAccessibilities
): Accessibility {
    if (
        accessService === AccessServiceTypes.AUDIODESCRIPTION ||
        accessService === ContentoAccessibilities.AUDIO_DESCRIBED
    ) {
        return Accessibility.AudioDescribed;
    }
    if (
        accessService === AccessServiceTypes.SIGNINTERPRETATION ||
        accessService === ContentoAccessibilities.SIGN_INTERPRETED ||
        accessService === AccessServiceTypes.SIGN_LANGUAGE
    ) {
        return Accessibility.SignInterpreted;
    }

    return Accessibility.Default;
}

export function hasAccessService(accessService: AccessServiceTypes | ContentoAccessibilities): boolean {
    return Boolean(getAccessServiceDescription(accessService));
}

export default AccessServiceTypes;
